import React, { memo } from 'react';
import { StyleSheet, Text } from 'react-native';
import { COLORS, FONTS } from '@bcm/constants';

import IconMap from '../../UI/icon/IconMap';
import GlobalPressable from '../../UI/button/GlobalPressable';
import Icon from '../../UI/icon/Icon';

const BodySiteCanvasBack = ({onCancel, dims}) => {
	const width = dims.width / 7;

	const styles = StyleSheet.create({
		container: {
			position: 'absolute',
			left: (dims.width / 6) - (width / 2),
			top: (dims.height / 10) - (width / 2),
			elevation: 20,
			zIndex: 20,
			width,
			height: width,
			borderRadius: width / 2,
			backgroundColor: COLORS.buttonBackground,
			justifyContent: 'center',
			alignItems: 'center',

		},
	});
	return (
		<GlobalPressable
			style={styles.container}
			onPress={onCancel}
		>
			<Icon
				icon={IconMap.canvasBack}
				size={width / 1.5}
			/>
			<Text style={{
				fontSize: width / 5,
				fontFamily: FONTS.default,
				height: width / 5,
				transform: [{
					translateY: - width / 6,
				}],
			}}>
				{'Back'}</Text>
		</GlobalPressable>
	);
};

export default memo(BodySiteCanvasBack);